/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancel_YesInputs */

const en_cancel_yes = /** @type {(inputs: Cancel_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, cancel`)
};

const de_cancel_yes = /** @type {(inputs: Cancel_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja, kuendigen`)
};

const fr_cancel_yes = /** @type {(inputs: Cancel_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui, annuler`)
};

const es_cancel_yes = /** @type {(inputs: Cancel_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si, cancelar`)
};

const it_cancel_yes = /** @type {(inputs: Cancel_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si, annulla`)
};

const nl_cancel_yes = /** @type {(inputs: Cancel_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja, annuleren`)
};

const pl_cancel_yes = /** @type {(inputs: Cancel_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tak, anuluj`)
};

const fi_cancel_yes = /** @type {(inputs: Cancel_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kylla, peruuta`)
};

const da_cancel_yes = /** @type {(inputs: Cancel_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja, annuller`)
};

const sv_cancel_yes = /** @type {(inputs: Cancel_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja, avbryt`)
};

/**
* | output |
* | --- |
* | "Yes, cancel" |
*
* @param {Cancel_YesInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cancel_yes = /** @type {((inputs?: Cancel_YesInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_YesInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cancel_yes(inputs)
	if (locale === "fr") return fr_cancel_yes(inputs)
	if (locale === "es") return es_cancel_yes(inputs)
	if (locale === "it") return it_cancel_yes(inputs)
	if (locale === "nl") return nl_cancel_yes(inputs)
	if (locale === "pl") return pl_cancel_yes(inputs)
	if (locale === "fi") return fi_cancel_yes(inputs)
	if (locale === "da") return da_cancel_yes(inputs)
	if (locale === "sv") return sv_cancel_yes(inputs)
	return en_cancel_yes(inputs)
});